// lib/island/fuzzy.ts
// Minimaler Subsequence-Fuzzy-Matcher mit Wortanfangs-/Kontinuitäts-Bonus.
// Reine Funktionen, kein State — vollständig getestet.

export interface HighlightSegment {
  text: string;
  match: boolean;
}

const WORD_BOUNDARY = /[\s\-_./]/;

/**
 * Score für `query` gegen `text`. Höher = besser. `null` = kein Match
 * (nicht alle Query-Zeichen in Reihenfolge vorhanden). Leere Query → 0.
 */
export function fuzzyScore(query: string, text: string): number | null {
  const q = query.toLowerCase();
  if (q.length === 0) return 0;
  const t = text.toLowerCase();

  let score = 0;
  let ti = 0;
  let prevMatchIdx = -2;
  for (let qi = 0; qi < q.length; qi++) {
    const ch = q[qi];
    const found = t.indexOf(ch, ti);
    if (found === -1) return null;
    score += 1;
    if (found === prevMatchIdx + 1) score += 5;
    if (found === 0 || WORD_BOUNDARY.test(t[found - 1])) score += 3;
    prevMatchIdx = found;
    ti = found + 1;
  }
  score -= text.length * 0.01;
  return score;
}

/**
 * Zerlegt `text` in Segmente, markiert die Zeichen, die die `query`-
 * Subsequence matchen. Für UI-Highlighting. Bei leerer/erfolgloser Query:
 * ein einzelnes unmarkiertes Segment.
 */
export function highlightSegments(query: string, text: string): HighlightSegment[] {
  const q = query.toLowerCase();
  if (q.length === 0) return [{ text, match: false }];
  const t = text.toLowerCase();

  const matchedIdx: number[] = [];
  let ti = 0;
  for (let qi = 0; qi < q.length; qi++) {
    const found = t.indexOf(q[qi], ti);
    if (found === -1) return [{ text, match: false }];
    matchedIdx.push(found);
    ti = found + 1;
  }

  const segs: HighlightSegment[] = [];
  let cur = '';
  let curMatch = false;
  const matchSet = new Set(matchedIdx);
  for (let i = 0; i < text.length; i++) {
    const isMatch = matchSet.has(i);
    if (i === 0) { curMatch = isMatch; cur = text[i]; continue; }
    if (isMatch === curMatch) { cur += text[i]; }
    else { segs.push({ text: cur, match: curMatch }); cur = text[i]; curMatch = isMatch; }
  }
  if (cur) segs.push({ text: cur, match: curMatch });
  return segs;
}
